import React, { useState } from 'react';
import { Modal } from './ui/Modal';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [openModal, setOpenModal] = useState<ModalType>(null);
  const currentYear = new Date().getFullYear();
  return <>
      <footer className="py-12 bg-warm-50 border-t border-warm-200" data-id="element-60">
        <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-6 text-sm text-warm-400" data-id="element-61">
          <p data-id="element-62">© {currentYear} Proteína Lista. Todos los derechos reservados.</p>

          <nav className="flex items-center gap-6" data-id="element-63">
            <button onClick={() => setOpenModal('privacy')} className="hover:text-teal-600 transition-colors underline decoration-transparent hover:decoration-teal-600 underline-offset-4" data-id="element-64">
              Política de Privacidad
            </button>
            <button onClick={() => setOpenModal('terms')} className="hover:text-teal-600 transition-colors underline decoration-transparent hover:decoration-teal-600 underline-offset-4" data-id="element-65">
              Términos y Condiciones
            </button>
          </nav>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <Modal isOpen={openModal === 'privacy'} onClose={() => setOpenModal(null)} title="Política de Privacidad" data-id="element-66">
        <div className="space-y-4" data-id="element-67">
          <p data-id="element-68">Última actualización: {currentYear}</p>

          <h3 className="text-lg font-bold text-warm-900 mt-6" data-id="element-69">
            1. Recopilación de Información
          </h3>
          <p data-id="element-70">
            Recopilamos información que usted nos proporciona directamente
            cuando realiza una compra, se suscribe a nuestro boletín o se
            comunica con nosotros. Esta información puede incluir su nombre,
            dirección de correo electrónico e información de pago.
          </p>

          <h3 className="text-lg font-bold text-warm-900 mt-6" data-id="element-71">
            2. Uso de la Información
          </h3>
          <p data-id="element-72">
            Utilizamos la información recopilada para procesar sus
            transacciones, enviarle el contenido digital adquirido y
            proporcionarle actualizaciones sobre nuestros productos y servicios.
          </p>

          <h3 className="text-lg font-bold text-warm-900 mt-6" data-id="element-73">
            3. Protección de Datos
          </h3>
          <p data-id="element-74">
            Implementamos medidas de seguridad diseñadas para proteger su
            información personal contra acceso no autorizado y uso indebido. No
            vendemos ni compartimos su información personal con terceros para
            fines de marketing.
          </p>

          <h3 className="text-lg font-bold text-warm-900 mt-6" data-id="element-75">4. Cookies</h3>
          <p data-id="element-76">
            Utilizamos cookies y tecnologías similares para mejorar su
            experiencia en nuestro sitio web y analizar cómo se utiliza nuestro
            servicio.
          </p>
        </div>
      </Modal>

      {/* Terms of Service Modal */}
      <Modal isOpen={openModal === 'terms'} onClose={() => setOpenModal(null)} title="Términos y Condiciones" data-id="element-77">
        <div className="space-y-4" data-id="element-78">
          <p data-id="element-79">
            Por favor, lea estos términos cuidadosamente antes de utilizar
            nuestro servicio.
          </p>

          <h3 className="text-lg font-bold text-warm-900 mt-6" data-id="element-80">
            1. Aceptación de los Términos
          </h3>
          <p data-id="element-81">
            Al acceder y utilizar este sitio web y comprar nuestros productos
            digitales, usted acepta estar sujeto a estos términos y condiciones.
          </p>

          <h3 className="text-lg font-bold text-warm-900 mt-6" data-id="element-82">
            2. Propiedad Intelectual
          </h3>
          <p data-id="element-83">
            Todo el contenido incluido en este sitio, como texto, gráficos,
            logotipos, imágenes y descargas digitales, es propiedad de Proteína
            Lista y está protegido por las leyes de derechos de autor. La compra
            de nuestros productos digitales le otorga una licencia personal y no
            transferible para su uso.
          </p>

          <h3 className="text-lg font-bold text-warm-900 mt-6" data-id="element-84">
            3. Política de Reembolso
          </h3>
          <p data-id="element-85">
            Debido a la naturaleza digital de nuestros productos, todas las
            ventas son finales. Sin embargo, si experimenta problemas técnicos
            con su descarga, por favor contáctenos para recibir asistencia.
          </p>

          <h3 className="text-lg font-bold text-warm-900 mt-6" data-id="element-86">
            4. Limitación de Responsabilidad
          </h3>
          <p data-id="element-87">
            Proteína Lista no será responsable de ningún daño directo,
            indirecto, incidental o consecuente que resulte del uso o la
            imposibilidad de uso de nuestros productos.
          </p>
        </div>
      </Modal>
    </>;
}